<template>
  <div class="container-fluid py-4">
    <h1 class="h3 mb-4">
      <i class="bi bi-graph-up me-2"></i>
      Dashboard de Monitoreo
    </h1>
    <div class="card">
      <div class="card-body">
        <p class="text-muted">Panel de monitoreo en desarrollo...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonitoringDashboard'
}
</script>
